import { HttpParams } from '@angular/common/http';

export class Filter {
    ordering?: string;

    /*
    This method gets the params for send to server 
    */
    getQueryParams(): HttpParams {
        let queryParams = new HttpParams();
        Object.keys(this).forEach((key) => {
            let value = (this as any)[key];
            if (value) {
                if (value instanceof Date) {
                    value = value.toISOString();
                }
                queryParams = queryParams.append(key, value);
            }
        });
        return queryParams;
    }
}
